import React, { Component} from 'react';
import MetaTags from 'react-meta-tags';
import {ResGet,url} from './component/resapi'
import HeaderTwo from './HeaderTwo'
import AboutMember from './component/aboutMember'
import Plyr from 'react-plyr';
import './asset/css/video.css';
import imagesLoead from './component/utility/imageLoad'
import {connect} from 'react-redux';
import {isLoading} from "./redux/actions"
import Div100vh from 'react-div-100vh'
class About extends Component {
  constructor(props){
    super(props);
    this.state = {
      _isPlayMusic : "play",
      playList : 0,
      data:[],
      loading :true,

    }
  }
  handelTogglePlay=()=>{
    if(this.state._isPlayMusic==="play") {
      this.refs.audioPlay.play()
      this.setState({_isPlayMusic: "pause"})
    }
    else {
      this.refs.audioPlay.pause()
      this.setState({_isPlayMusic: "play"})
    }    
  }
  handelNextMusic=()=>{
      this.setState({playList:this.state.playList+1})
  }
  componentDidMount(){
    this.props.isLoading(false)
    ResGet("getabout").then((response)=>{
      if(response.status===200){
        this.setState({data:response.data[response.data.length-1],loading:false})
        setTimeout(() => {
          imagesLoead(()=>this.props.isLoading(true))
        }, 1000);
        
      }
    })
  }
  handelCursor(value){
    if(value){
      document.querySelector(".cursor--outer").style.display="none"
      document.querySelector("body").style.cursor="default"
    }
    else {
      document.querySelector(".cursor--outer").style.display="block"
      document.querySelector("body").style.cursor="none"
    }
  }
  render(){
  return (
    <Div100vh style={{height:"100rvh",overflow:"hidden"}}>
    <div className="bg-fixed-light">
        <HeaderTwo w={true}/>
        <MetaTags>
            {/* <meta name="description" content={} /> */}

            <meta property="og:title" content="About Tunnel graphic" />
        </MetaTags>
        <div className="container-main about">
          <div className="container">
          <div className="header">
          {this.state.data.sound?
          <audio ref="audioPlay" preload="none" onEnded={()=>this.setState({_isPlayMusic: "play"})}>
            <source src={url+"/"+this.state.data.sound} type="audio/mp3"/>
          </audio>
          :""}
            {/* <span><i className="icon icon-fast-backward"></i></span> */}
              {/* <span className="clickable" onClick={()=>this.handelTogglePlay()}></span> */}
              {!this.state.loading?<span className="clickable" onClick={()=>this.handelTogglePlay()}>Listen our music<i className={`icon icon-${this.state._isPlayMusic}`}></i></span>:""}
            {/* <span onClick={()=>this.handelNextMusic()}><i className="icon icon-fast-forward"></i></span> */}
          </div>
            <div className="ltr">
            <div className="row">
                <div className="singlepost">
                  <div className="text">
                   <h1>About</h1>
                   <div className="txt" dangerouslySetInnerHTML={{__html: this.state.data.html}} />
                   {this.state.data.video?
                   <div className="video"
                    onMouseEnter={()=>this.handelCursor(true)}
                    onMouseLeave={()=>this.handelCursor(false)}
                    >
                    <Plyr
                        type="video"
                        volume={0}
                        // ref={full}
                        fullscreen={ {enabled: true, fallback: true, iosNative: true} }
                        controls={[ 'play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'pip', 'airplay', 'fullscreen' ]}
                        url={url+"/"+this.state.data.video}
                      />
                    </div>
                    :""}
                   {/* <img src="https://images.unsplash.com/photo-1500238899953-fb0f434d7efa?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"/> */}
                  </div>
                  <div className="social">
                    <span>FOLLOW US :</span>
                    {!this.state.loading?
                    <>
                    <a href={this.state.data.soical.facebook} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-facebook"></i></a>
                    <a href={this.state.data.soical.linkedin} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-linkedin"></i></a>
                    <a href={this.state.data.soical.twitter} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-twitter"></i></a>
                    <a href={this.state.data.soical.instagram} target="_blank" rel="noopener noreferrer" className="clickable"><i className="icon icon-instagram"></i></a>
                    </>
                    :""}
                  </div>

                  {!this.state.loading && this.state.data.members.length>0?<AboutMember title="Members" data={this.state.data.members}/>:""}
                </div>
            </div>
            </div>
          </div>
        </div>
    </div>
    </Div100vh>
  );
  }
}

export default connect(null,{isLoading})(About);
